import React from 'react';
import PropTypes from 'prop-types';
import { Header, NoData } from 'rp-react-table';
import { keys, isEmpty } from 'lodash';
import columns from './columns';
import RaceRow from './raceRow/RaceRow';

const sectionTitles = {
    '1988ToDate': '1988 to Date',
    '2000ToDate': '2000 to Date',
    currentYear: 'Current Year',
};

const noDataText = 'No progeny statistics for this sire in the Racing Post database';
const tableClassName = 'ui-table ui-table_type2 hp-progeny-statistics__table';

const ProgenyStatistics = ({ data: { progenyStatistics }, params: { id } }) => (
    <section className="hp-progeny-statistics">
        { isEmpty(progenyStatistics) ? <NoData text={noDataText} /> :
            keys(progenyStatistics).map((timePeriod) => {
                const data = progenyStatistics[timePeriod];

                return isEmpty(data) ? null : (
                    <div key={timePeriod}>
                        <h2>{sectionTitles[timePeriod]}</h2>
                        <table className={tableClassName}>
                            <Header columns={columns} />
                            {data.map(rowData => (
                                <RaceRow
                                    key={rowData.category}
                                    data={rowData}
                                    horseId={id}
                                    timePeriod={timePeriod}
                                />
                            ))}
                        </table>
                    </div>
                );
            })
        }
    </section>
);

const statisticsRow = PropTypes.shape({
    category: PropTypes.string,
    winners: PropTypes.number,
    runners: PropTypes.number,
    percentWinnersRunners: PropTypes.number,
    wins: PropTypes.number,
    runs: PropTypes.number,
    percentWinsRuns: PropTypes.number,
    place2ndNumber: PropTypes.number,
    place3rdNumber: PropTypes.number,
    totalPrizeMoney: PropTypes.number,
});

ProgenyStatistics.propTypes = {
    data: PropTypes.shape({
        progenyStatistics: PropTypes.shape({
            '1988ToDate': PropTypes.arrayOf(statisticsRow),
            '2000ToDate': PropTypes.arrayOf(statisticsRow),
            currentYear: PropTypes.arrayOf(statisticsRow),
        }),
    }).isRequired,
    params: PropTypes.shape({
        id: PropTypes.string,
    }).isRequired,
};

export default ProgenyStatistics;



// WEBPACK FOOTER //
// ./src/js/horse/progenyStatistics/ProgenyStatistics.jsx